import type { CandleWithFlag } from "features/chart";

export interface FractalPoints {
  up: boolean[];
  down: boolean[];
}

export function calcFractal(data: CandleWithFlag[], period: number): FractalPoints {
  const n = data.length;
  const up = new Array<boolean>(n).fill(false);
  const down = new Array<boolean>(n).fill(false);

  for (let i = period; i < n - period; i++) {
    let isUp = true, isDown = true;
    for (let j = 1; j <= period; j++) {
      if (data[i].high <= data[i - j].high || data[i].high <= data[i + j].high) isUp = false;
      if (data[i].low >= data[i - j].low || data[i].low >= data[i + j].low) isDown = false;
    }
    up[i] = isUp;
    down[i] = isDown;
  }

  return { up, down };
}
